import { useMemo } from 'react';
import { Textarea as MantineTextarea } from '@mantine/core';
import { useId, useUncontrolled } from '@mantine/hooks';
import clsx from 'clsx';

import { FormLabel } from '../formlabel/FormLabel';
import { LoadingIndicator } from '../loading-indicator/LoadingIndicator';

import inputStyles from '../input/input.module.scss';
import textareaStyles from './textarea.module.scss';

export type TextareaProps = {
  autosize?: boolean;
  defaultValue?: string;
  disabled?: boolean;
  error?: string;
  inlineError?: boolean;
  label?: string;
  loading?: boolean;
  maxRows?: number;
  minRows?: number;
  onChange?: (newValue: string) => void;
  placeholder?: string;
  readOnly?: boolean;
  required?: boolean;
  tableLayout?: boolean;
  value?: string;
};

export function Textarea({
  autosize,
  defaultValue,
  disabled,
  error,
  inlineError,
  label,
  loading,
  maxRows,
  minRows,
  onChange,
  placeholder,
  readOnly,
  required,
  tableLayout,
  value,
}: TextareaProps) {
  const id = useId();
  const rightSection = useMemo(
    () => (loading ? <LoadingIndicator /> : undefined),
    [loading]
  );
  const [text, setText] = useUncontrolled({
    value,
    defaultValue,
    onChange,
  });
  return (
    <div className={clsx({ [inputStyles['root--table-layout']]: tableLayout })}>
      <FormLabel
        disabled={disabled}
        error={error}
        id={id}
        inline={inlineError}
        label={label}
        loading={loading}
        required={required}
      />
      <MantineTextarea
        autosize={autosize}
        classNames={{
          wrapper: inputStyles['wrapper'],
          input: clsx(inputStyles['input'], textareaStyles['input'], {
            [inputStyles['input--error']]: error != null,
          }),
          section: inputStyles['section'],
        }}
        disabled={disabled || loading}
        id={id}
        maxRows={maxRows}
        minRows={minRows}
        placeholder={placeholder}
        onChange={({ target }) => setText(target.value)}
        readOnly={readOnly}
        rightSection={rightSection}
        unstyled
        value={text}
      ></MantineTextarea>
    </div>
  );
}
